<span [style.background-color]="color" class="icon-shape invert-filter">
  <i-feather [name]="icon" [class]="classIcon"></i-feather>
</span>
